import settings from './settings'

export const AGE_RANGE_OPTIONS = [
  { text: "below 18", value: '1' },
  { text: "18 - 24", value: '2'},
  { text: "25 - 35", value: '3'},
  { text: "35 - 55", value: '4'},
  { text: "over 55", value: '5' }
];

export const AUTH_COOKIE_PATH = 'authToken';

export const ONBOARDING_STEPS_MAP = {
  user_info: '/user/info',
  profile: '/my',
  'apply_to_list': '/organizations/apply'
};


export const FACEBOOK_APPID = settings.facebook.appId



// WEBPACK FOOTER //
// ./src/constants.js